import { useLocation } from "react-router-dom";
import useCustomQuery from "../../../../../../hooks/useCustomQuery";
import ManualReceiptService from "../../../../../../services/billing_services/processing/manualReceipt.service";
import ManualReceiptTemplate from "../_components/invoice-template/ManualReceiptTemplate";
import { useEffect } from "react";
import { LoadState } from "../../../../../../enum/loading-state";
import Loader from "../../../_components/helpers/Loader";

export default function ViewManualReceiptPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const invoiceId = searchParams.get("InvoiceId");
  const idToken = searchParams.get("IdToken");

  // fetch manual receitpt  details by id
  const queryReceiptDetails = useCustomQuery(
    ["fetchManualReceiptDetails"],
    () =>
      ManualReceiptService.publicManualReceiptDetailsById({
        invoiceId,
        idToken,
      })
  );

  useEffect(() => {
    queryReceiptDetails.refetch();
  }, []);

  return (
    <div>
      {queryReceiptDetails.status === LoadState.Loading ? (
        <Loader />
      ) : queryReceiptDetails.status === LoadState.Error ? (
        <p> Oops. Something went wrong. Page not reachable.</p>
      ) : (
        <ManualReceiptTemplate receiptDetails={queryReceiptDetails.result} />
      )}
    </div>
  );
}
